import { useMemo } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import BackHeader from '../../components/BackHeader/BackHeader'
import { useLoginModal } from '../../components/LoginModalContext'
import Picture from '../../images/Svirr.png'
import yatzyIcon from '../../images/yatzyTrans.png'
import championsLeagueIcon from '../../images/uefaChampionsLeague.jpg'
import worldCupIcon from '../../images/World-CUp-2026.jpg'
import landskampIcon from '../../images/landskamp.jpg'
import kampdagIcon from '../../images/kampdagIcon.svg'
import profileIcon from '../../images/user_logo.svg'
import gamesIcon from '../../images/spil.png'
import adminIcon from '../../images/adminAppIcon.svg'
import holdIcon from '../../images/hold-ball.png'
import './HomePage.css'

const games = [
  {
    label: 'Yatzy',
    path: '/yatzy',
    key: 'yatzy',
    accessKey: 'yatzy',
    image: yatzyIcon,
    fit: 'contain',
    background: '#111111',
  },
  {
    label: 'CL spil',
    path: '/champions-league',
    key: 'championsLeague',
    accessKey: 'championsLeague',
    image: championsLeagueIcon,
    fit: 'cover',
    position: '12% center',
  },
  {
    label: 'World Cup',
    path: '/world-cup-2026/teams',
    key: 'worldCup2026',
    accessKey: 'worldCup2026',
    image: worldCupIcon,
    fit: 'cover',
    position: 'center 42%',
  },
  {
    label: 'Landskamp',
    path: '/landskamp',
    key: 'landskamp',
    accessKey: 'landskamp',
    image: landskampIcon,
    fit: 'cover',
    position: 'center 46%',
  },
  {
    label: 'Kampdag',
    path: '/kampdag',
    key: 'kampdag',
    accessKey: 'kampdag',
    image: kampdagIcon,
    fit: 'cover',
  },
]

function AppButton({ app, onClick }) {
  const icon = (
    <span
      className="home-app-icon"
      style={{ background: app.background || 'transparent' }}
    >
      <img
        className={[
          'home-app-image',
          app.fit === 'contain' ? 'home-app-image--contain' : '',
          app.invert ? 'home-app-image--invert' : '',
        ].filter(Boolean).join(' ')}
        src={app.image}
        alt=""
        style={{
          objectPosition: app.position || 'center',
          ...(app.scale ? { width: `${app.scale}%`, height: `${app.scale}%` } : {}),
        }}
      />
    </span>
  )

  if (onClick) {
    return (
      <button type="button" className="home-app" onClick={onClick}>
        {icon}
        <span className="home-app-label">{app.label}</span>
      </button>
    )
  }

  return (
    <Link className="home-app" to={app.path}>
      {icon}
      <span className="home-app-label">{app.label}</span>
    </Link>
  )
}

function HomePage() {
  const location = useLocation()
  const navigate = useNavigate()
  const { openLogin } = useLoginModal()
  const user = useSelector((state) => state.mate.currentUser)
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated)
  const token = useSelector((state) => state.auth.token)
  const isLoggedIn = isAuthenticated && !!token && !!user
  const isAdmin = user?.role === 'admin'
  const showGames = location.pathname === '/spil'

  const visibleGames = useMemo(() => {
    if (!isLoggedIn || isAdmin) {
      return games
    }

    const pageAccess = user?.pageAccess || []
    return games.filter((app) => pageAccess.includes(app.accessKey))
  }, [isAdmin, isLoggedIn, user?.pageAccess])

  const homeApps = useMemo(() => {
    const apps = [
      {
        label: 'Profil',
        path: '/profile',
        key: 'profile',
        image: profileIcon,
        fit: 'contain',
        background: '#000000',
        requiresLogin: true,
      },
      {
        label: 'Hold',
        path: '/hold',
        key: 'hold',
        image: holdIcon,
        fit: 'contain',
        scale: 82,
      },
      {
        label: 'Spil',
        path: '/spil',
        key: 'games',
        image: gamesIcon,
        fit: 'contain',
        scale: 70,
        background: '#000000',
        invert: true,
      },
    ]

    if (isAdmin) {
      apps.push({
        label: 'Admin',
        path: '/admin',
        key: 'admin',
        image: adminIcon,
        fit: 'cover',
      })
    }

    return apps
  }, [isAdmin])

  const visibleApps = showGames ? visibleGames : homeApps

  return (
    <main className="home-screen">
      <img className="home-screen-logo" src={Picture} alt="Svirr" />
      {showGames ? (
        <BackHeader
          title="Spil"
          subtitle="Vælg et spil"
          onBack={() => navigate('/')}
        />
      ) : user?.name ? (
        <BackHeader
          className="home-screen-bar"
          title={user.name}
        />
      ) : null}

      {visibleApps.length > 0 ? (
        <nav className="home-app-grid" aria-label={showGames ? 'Spil' : 'Forside'}>
          {visibleApps.map((app) => (
            <AppButton
              key={app.key}
              app={app}
              onClick={app.requiresLogin && !isLoggedIn ? openLogin : undefined}
            />
          ))}
        </nav>
      ) : (
        <p className="home-app-empty">Du har ikke adgang til nogen spil endnu.</p>
      )}
    </main>
  )
}

export default HomePage
